export default __webpack_public_path__ + "static/media/19t.a233f5bd.jpg";